import React, { useState, useEffect } from 'react';
import HomePage from './components/HomePage';
import TodoListPage from './components/TodoListPage';

// Lightweight client-side router based on window.location.pathname
// Routes:
//   /          -> HomePage
//   /:listId   -> TodoListPage (10-char alphanumeric)

function getListIdFromPath() {
  const path = window.location.pathname.replace(/^\//, '').split('/')[0];
  if (/^[A-Za-z0-9]{10}$/.test(path)) return path;
  return null;
}

const App = () => {
  const [listId, setListId] = useState(getListIdFromPath);

  useEffect(() => {
    const onPop = () => setListId(getListIdFromPath());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const navigateTo = (id) => {
    const path = id ? `/${id}` : '/';
    window.history.pushState({}, '', path);
    setListId(id || null);
    window.scrollTo(0, 0);
  };

  if (listId) {
    return (
      <TodoListPage
        listId={listId}
        onNavigateHome={() => navigateTo(null)}
      />
    );
  }

  return <HomePage onNavigate={(id) => navigateTo(id)} />;
};

export default App;
